import type { FundDatum } from "@/FundExplorer/types";
import getGroupKey from "@/lib/getGroupKey";
import type { EntityKey } from "hsl-core/FundExplorer";
import useGroupedList from "./useGroupedList";

export default function useGroupedFunds(
	funds: FundDatum[],
	groupKeys: EntityKey[],
	priorityList?: string[],
) {
	const props = groupKeys
		.map((gk) => gk.split(".")[1])
		.filter((prop) => prop && prop.length > 0);
	if (!props.length) {
		return;
	}
	const [p1, p2] = props;
	const getKey = getGroupKey.bind(
		null,
		p1 as keyof FundDatum,
		p2 as keyof FundDatum,
	);

	return useGroupedList(funds, getKey, priorityList);
}
